import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { SITE_URL } from '@/lib/seo';

export default function SafetyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <div className="pt-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-3">
          <nav aria-label="breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-primary-600 transition-colors">Home</a></li>
              <li><i className="ri-arrow-right-s-line text-xs" /></li>
              <li><span className="text-foreground-700">Safety Center</span></li>
            </ol>
          </nav>
        </div>
      </div>

      <main className="flex-1 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">Safety Center</h1>
        <p className="text-foreground-600 mb-8 leading-relaxed">
          Buying through international marketplaces requires careful research and attention to safety.
          This safety center provides essential guidance to help you protect yourself while using
          AllChinaBuy or any similar buying agent platform.
        </p>

        <div className="space-y-6">
          {[
            {
              title: 'Is AllChinaBuy Legit?',
              content: 'AllChinaBuy operates as a buying agent, which is a recognized business model. However, like any platform, individual experiences vary. Always research sellers independently and follow safety best practices.'
            },
            {
              title: 'How to Verify Sellers',
              content: 'Check seller history, review ratings from other buyers, examine product listings for completeness, and start with small test orders before making larger purchases.'
            },
            {
              title: 'Account Security',
              content: 'Use strong, unique passwords. Enable two-factor authentication if available. Never share your login credentials. Monitor your account for unauthorized activity.'
            },
            {
              title: 'Payment Safety',
              content: 'Always use the platform official payment system. Avoid wire transfers to individual sellers. Use payment methods that offer buyer protection. Be cautious of requests for payment outside the platform.'
            },
            {
              title: 'QC Verification',
              content: 'Always review QC photos before approving shipment. Compare photos to the original listing. Request additional photos if needed. Do not approve shipment if you have concerns.'
            },
            {
              title: 'Shipping Risks',
              content: 'Understand that international shipping involves risks including delays, damage, and customs inspections. Choose appropriate shipping methods based on your needs. Consider shipping insurance for valuable items.'
            },
            {
              title: 'Common Scams to Avoid',
              content: 'Watch for sellers requesting payment outside the platform, deals that seem too good to be true, pressure to complete transactions quickly, and sellers with no verifiable history or reviews.'
            }
          ].map((item, idx) => (
            <div key={idx} className="p-5 bg-background-50 rounded-xl border border-background-200">
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Safety Center",
          "url": `${SITE_URL}/safety/`,
          "description": "AllChinaBuy safety center with essential guidance on seller verification, account security, payment safety, QC checks and common scams."
        })}
      </script>
    </div>
  );
}